export const DATE_FORMAT = {
  main: 'MMM Do YY',
  primary: 'YYYY-MM-DD',
  secondary: 'DD-MM-YYYY',
  chat: 'MMM DD, h:mm a',
};
